<template>
  <div>
    <Toolbar :handle-submit="onSendForm" :handle-reset="resetForm">
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-format-color-fill</v-icon>{{$t('profile.material.mediums')}}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>
    <MaterialMediumForm ref="createForm" :values="item" :errors="violations" />
    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { createHelpers } from 'vuex-map-fields';
import MaterialMediumForm from '../../components/materialmedium/Form';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import CreateMixin from '../../mixins/CreateMixin';

const servicePrefix = 'MaterialMedium';

const { mapFields } = createHelpers({
  getterType: 'materialmedium/getField',
  mutationType: 'materialmedium/updateField'
});

export default {
  name: 'MaterialMediumCreate',
  servicePrefix,
  mixins: [CreateMixin],
  components: {
    Loading,
    Toolbar,
    MaterialMediumForm
  },
  data() {
    return {
      item: {}
    };
  },
  computed: {
    ...mapFields(['error', 'isLoading', 'created', 'violations'])
  },
  methods: {
    ...mapActions('materialmedium', ['create', 'reset'])
  }
};
</script>
